// extracted by mini-css-extract-plugin
export default {"loaderWrap":"loaders_loaderWrap__mWDvt","loader":"loaders_loader__+1F3S","rotate":"loaders_rotate__wbKcj","ball1":"loaders_ball1__JEVlu","ball2":"loaders_ball2__9dSUl"};